import { RouteRecordRaw } from 'vue-router'

import CreatePassword from '@/popup/components/views/Onboard/CreateNewAccount/CreatePassword.vue'
import ConfirmPassword from '@/popup/components/views/Onboard/CreateNewAccount/ConfirmPassword.vue'

const createNewAccountRoutes: Array<RouteRecordRaw> = [
  {
    path: '/create-account/create-new-password',
    name: 'createNewPassword',
    component: CreatePassword,
  },
  {
    path: '/create-account/confirm-password',
    name: 'confirmPassword',
    component: ConfirmPassword,
  },
]

export default createNewAccountRoutes
